const DataSourceDetailUserContextParam = {
  schemaFilter: { paramType: "string" }
};
export {
  DataSourceDetailUserContextParam
};
//# sourceMappingURL=DataSourceDetailUserContextParams.js.map
